import { Config } from '#app/config'

const basePath = Config.WEBSITE_URL as 'https://grafbase.com'
const docsPath = `${basePath}/docs` as const

/** Links to the Grafbase website at https://grafbase.com */
export const websitePaths = {
  home: basePath,
  changelog: `${basePath}/changelog`,
  terms: `${basePath}/terms`,
  privacy: `${basePath}/privacy`,
  docs: {
    overview: docsPath,
    checks: `${docsPath}/schema-checks`,
    operationChecks: `${docsPath}/schema-checks/operation-checks`,
    envVars: `${docsPath}/projects/environment-variables`,
    registry: `${docsPath}/schema-registry`,
    selfHostedGateway: `${docsPath}/self-hosted-gateway`,
    tokens: `${docsPath}/accounts/access-tokens`,
  },
  pricing: `${basePath}/pricing`,
  contactSales: `${basePath}/contact/sales`,
} as const
